
import { defineComponent, PropType } from 'vue'

interface SelectOption {
  text: string,
  value: string,
}
export default defineComponent({
  emits: ['onChange'],
  props: {
    name: String as PropType<string>,
    value: String as PropType<string>,
    id: String as PropType<string>,
    options: Object as PropType<SelectOption[]>
  },
  methods: {
    handleOnChange (event: Event) {
      this.$emit('onChange', (event.target as HTMLSelectElement).value)
    }
  }
})
